<template>
<div>

    <div class="row p-2">
      <div class="col-12 underline d-flex align-items-center justify-content-between">
        <div class="searchTitle">{{$ml.get('OPPORTUNITIES')}}</div>
        <!-- <a href="https://www.minimumcrm.com/raporlar-satis-analizi#firsat-tab" target="_blank" class="btn btn-primary text-white px-3 font-weight-bold mb-2 btnHelp"><span class="fas fa-exclamation-circle pr-2"></span>{{$ml.get('HELP')}}</a> -->
      </div>
      <hr>
    </div>
    
  <div class="row py-2">
      <div class="col-12 p-0">
           <div class="row w-100">
            <div class="col-12 col-xl-6 d-flex justify-content-center justify-content-xl-start hpx-50">
                <div class="dealFilterMenu d-flex justify-content-center pl-3" v-show="userId=='all'">
                    <button type="button" :class="{active:setId == 0}" @click="setId=0" class="btn ">{{$ml.get('ALL')}}</button>
                    <button type="button" :class="{active:setId == 1}" @click="setId=1" class="btn ">{{$ml.get('OPEN_OPPORTUNITIES')}}</button>
                    <button type="button" :class="{active:setId == 2}" @click="setId=2" class="btn ">{{$ml.get('WON')}}</button>
                    <button type="button" :class="{active:setId == 3}" @click="setId=3" class="btn ">{{$ml.get('NOT_WON')}}</button>
                </div>                   
            </div>
            <div class="col-12 col-xl-6 text-right filter  d-flex align-items-center" id="userSelect">
                <div class="dealFilterMenu align-self-center">
                    <span class="text-center f-14 font-family-bold font-weight-normal m-0 d-flex align-items-center">{{formatDate(showDate.beginDate, "DD-MM-YYYY")}} - {{formatDate(showDate.endDate, "DD-MM-YYYY")}}</span>
                    <div>
                        <button type="button" v-if="!clickSelectUser && $can('can_see_other_users_deals_report')"  @click="clickSelectUser=true" class="btn f-14 asap-normal f-w-normal pl-3 pr-3 light-blue-border w-auto selectUser">{{$ml.get('SELECT_USER')}}</button>
                        <button type="button" :class="{active:setDate == 'selectDateButton'}" @click="setDate='selectDateButton'" class="btn f-14 asap-normal f-w-normal pl-3 pr-3 light-blue-border w-auto">{{$ml.get('SELECT_DATE')}}</button>
                    </div>
                </div>
            </div>
            <div class="float-right v-h-right row col-12 m-0 p-0 mt-2" v-if="setDate=='selectDateButton'">
                <div class="selectArea  d-flex mr-2">
                    <div class="first">
                        <v-select :options="dateTypeList" :reduce="name => name.value" v-model="dateTypeSelector" label="name" :searchable="false"/>
                    </div>
                    <div class="last searchInput">
                        <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="new-ctk" id="dealreport" :label="$ml.get('SELECT_DATE')" v-model="selectDate" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                    </div>
                </div>
                <button type="button" @click="setDate='selectDate',changeDate()" class="btn btn-sm f-14 asap-normal mr-2 f-w-normal light-blue-border w-auto dateOkeyButton">{{$ml.get('COMPLETE')}}</button>
                <button type="button" @click="setDate=undefined,changeDate()" class="btn btn-sm f-14 asap-normal f-w-normal light-blue-border w-auto dateCancelButton">{{$ml.get('CANCEL')}}</button>
            </div>
            <div class="row col-12 m-0 p-0 mt-2 v-h-right" v-if="clickSelectUser">
                <div class="v-h-right w-100">
                    <select v-model="userId" class="form-control input-padding border-radius-20 f-14 light-blue-border h-36 font-family-bold w-auto mr-2">
                        <option value="all">{{$ml.get('ALL_USERS')}}</option>
                        <option :value="u._id.$oid" :selected="u._id.$oid==user._id.$oid" :key="index" v-for="(u,index) in users">{{u.name}} {{u.surName}}</option>
                    </select>
                    <button type="button" @click="userId='all',clickSelectUser=undefined" class="btn btn-sm f-14 asap-normal f-w-normal light-blue-border w-auto dateCancelButton">{{$ml.get('CANCEL')}}</button>
                </div>
            </div>
            
        </div>
    </div>
    <div class="row w-100">
        <div class="col-12 pl-5 pt-3">
            <ul class="nav nav-tabs" id="dealsAQTab" role="tablist">
                <li class="nav-item" @click="tabs='currency'">
                    <a class="nav-link active f-15 font-family-bold font-weight-normal" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">{{$ml.get('AMOUNT')}} ({{numberWithCommas(toPriceModel(toFix(dealsTotalAmount)))}} {{currencyLabel(defaultCurrency)}})</a>
                </li>
                <li class="nav-item" @click="tabs='count'">
                    <a class="nav-link f-15 font-family-bold font-weight-normal" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">{{$ml.get('PIECE')}}</a>
                </li>
            </ul>
            <div class="tab-content" id="dealsAQTabContent">
                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                    <div class="row w-100 m-0">
                        <div class="col-12" v-show="setId==0">
                            <div class="row mt-4 mb-4" style="align-self: center;">
                                <div class="col-12 col-xl-6">
                                        <div class="align-self-center">
                                            <report-chart :data="pieData" :color="pieColor" />
                                        </div>
                                        <div class="align-self-center p-4">
                                            <p class="text-center f-15 font-family-bold font-weight-normal m-0">{{$ml.get('OPPORTUNITY_TL_GRAPHIC')}}</p> 
                                        </div>
                                </div>
                                <div class="col-12 col-xl-6 ">
                                    <div class="row">
                                        <div class="col-12 col-lg-6 ml-auto float-right">
                                            <div class="card border-warning">
                                                <div class="card-header bg-warning">
                                                    {{$ml.get('OPEN_OPPORTUNITIES')}}
                                                </div>
                                                <ul class="list-group list-group-flush">
                                                    <li class="list-group-item bg-light-warning"><span class="float-left">{{$ml.get('PIECE')}}</span>  <span class="float-right">{{info.open.count}}</span></li>
                                                    <li class="list-group-item bg-light-warning"><span class="float-left">{{$ml.get('AMOUNT')}}</span>  <span class="float-right">{{numberWithCommas(totalRounded(info.open.total))}} {{currencyLabel(defaultCurrency)}}</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row py-4">
                                        <div class="col-12 col-lg-6 ">
                                             <div class="card border-success">
                                                <div class="card-header bg-success">
                                                    {{$ml.get('WINNING_OPPORTUNITY')}}
                                                </div>
                                                <ul class="list-group list-group-flush">
                                                    <li class="list-group-item bg-light-success"><span class="float-left">{{$ml.get('PIECE')}}</span>  <span class="float-right">{{info.won.count}}</span></li>
                                                    <li class="list-group-item bg-light-success"><span class="float-left">{{$ml.get('AMOUNT')}}</span>  <span class="float-right">{{numberWithCommas(totalRounded(info.won.total))}} {{currencyLabel(defaultCurrency)}}</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-6 ">
                                            <div class="card border-danger">
                                                <div class="card-header bg-danger">
                                                    {{$ml.get('LOSS_OPPORTUNITY')}}
                                                </div>
                                                <ul class="list-group list-group-flush">
                                                    <li class="list-group-item bg-light-danger"><span class="float-left">{{$ml.get('PIECE')}}</span>  <span class="float-right">{{info.lose.count}}</span></li>
                                                    <li class="list-group-item bg-light-danger"><span class="float-left">{{$ml.get('AMOUNT')}}</span>  <span class="float-right">{{numberWithCommas(totalRounded(info.lose.total))}} {{currencyLabel(defaultCurrency)}}</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>                
                            </div>
                        </div>
                        <div class="col-12" v-show="setId>0">
                            <div class="row mt-4 mb-4 border " style="align-self: center;">
                                <div class="col-12 col-xl-3 pt-3" :class="{'light-green-border':greenActive,'light-red-border':redActive,'light-yellow-border':yellowActive,'light-grey-border':greyActive}">
                                    <div class="card" :class="{'border-warning':setId==1,'border-success':setId==2,'border-danger':setId==3}">
                                        <div class="card-header" :class="{'bg-warning':setId==1,'bg-success':setId==2,'bg-danger':setId==3}">
                                            <span v-if="setId==1">{{info.open.title}}</span>
                                            <span v-if="setId==2">{{info.won.title}}</span>
                                            <span v-if="setId==3">{{info.lose.title}}</span>
                                        </div>
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item " :class="{'bg-light-warning':setId==1,'bg-light-success':setId==2,'bg-light-danger':setId==3}">
                                                <span class="float-left">{{$ml.get('AMOUNT')}}</span> 
                                                <span class="float-right" v-if="setId==1">{{numberWithCommas(totalRounded(info.open.total))}} {{currencyLabel(defaultCurrency)}}</span>
                                                <span class="float-right" v-if="setId==2">{{numberWithCommas(totalRounded(info.won.total))}} {{currencyLabel(defaultCurrency)}}</span>
                                                <span class="float-right" v-if="setId==3">{{numberWithCommas(totalRounded(info.lose.total))}} {{currencyLabel(defaultCurrency)}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div> 
                                <div class="col-12 col-xl-9">
                                    <div class="align-self-center">
                                        <bar-chart :data="barChartData" class="mt-3" :color="pieColor" :options="barChartOptions" :labels="barChartLabels"></bar-chart>
                                    </div>
                                    <div class="align-self-center p-4">
                                        <p class="text-center f-15 font-family-bold font-weight-normal m-0">{{$ml.get('TL_PERSON_GRAPHIC')}}</p> 
                                    </div>
                                </div>           
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                    <div class="row w-100 m-0">
                        <div class="col-12" v-show="setId==0">
                            <div class="row mt-4 mb-4" style="align-self: center;">
                                <div class="col-12 col-xl-6 ">
                                        <div class="align-self-center">
                                            <report-chart :data="pieDataCount" :color="pieColor" />
                                        </div>
                                        <div class="align-self-center p-4">
                                            <p class="text-center f-15 font-family-bold font-weight-normal m-0">{{$ml.get('OPPORTUNITY_PIECE_GRAPHIC')}}</p> 
                                        </div>
                                </div>
                                <div class="col-12 col-xl-6 ">
                                    <div class="row">
                                        <div class="col-12 col-lg-6 ml-auto float-right">
                                            <div class="card border-warning">
                                                <div class="card-header bg-warning">
                                                    {{$ml.get('OPEN_OPPORTUNITIES')}}
                                                </div>
                                                <ul class="list-group list-group-flush">
                                                    <li class="list-group-item bg-light-warning"><span class="float-left">{{$ml.get('PIECE')}}</span>  <span class="float-right">{{info.open.count}}</span></li>
                                                    <li class="list-group-item bg-light-warning"><span class="float-left">{{$ml.get('AMOUNT')}}</span>  <span class="float-right">{{totalRounded(info.open.total)}} {{currencyLabel(defaultCurrency)}}</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row py-4">
                                        <div class="col-12 col-lg-6 ">
                                            <div class="card border-success">
                                                <div class="card-header bg-success">
                                                    {{$ml.get('WINNING_OPPORTUNITY')}}
                                                </div>
                                                <ul class="list-group list-group-flush">
                                                    <li class="list-group-item bg-light-success"><span class="float-left">{{$ml.get('PIECE')}}</span>  <span class="float-right">{{info.won.count}}</span></li>
                                                    <li class="list-group-item bg-light-success"><span class="float-left">{{$ml.get('AMOUNT')}}</span>  <span class="float-right">{{totalRounded(info.won.total)}} {{currencyLabel(defaultCurrency)}}</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-6 ">
                                            <div class="card border-danger">
                                                <div class="card-header bg-danger">
                                                    {{$ml.get('LOSS_OPPORTUNITY')}}
                                                </div>
                                                <ul class="list-group list-group-flush">
                                                    <li class="list-group-item bg-light-danger"><span class="float-left">{{$ml.get('PIECE')}}</span>  <span class="float-right">{{info.lose.count}}</span></li>
                                                    <li class="list-group-item bg-light-danger"><span class="float-left">{{$ml.get('AMOUNT')}}</span>  <span class="float-right">{{totalRounded(info.lose.total)}} {{currencyLabel(defaultCurrency)}}</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>               
                            </div>
                        </div>
                        <div class="col-12" v-show="setId>0">
                            <div class="row mt-4 mb-4 border " style="align-self: center;">
                                <div class="col-12 col-xl-3 pt-3" >
                                    <div class="card" :class="{'border-warning':setId==1,'border-success':setId==2,'border-danger':setId==3}">
                                        <div class="card-header" :class="{'bg-warning':setId==1,'bg-success':setId==2,'bg-danger':setId==3}">
                                            <span v-if="setId==1">{{info.open.title}}</span>
                                            <span v-if="setId==2">{{info.won.title}}</span>
                                            <span v-if="setId==3">{{info.lose.title}}</span>
                                        </div>
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item " :class="{'bg-light-warning':setId==1,'bg-light-success':setId==2,'bg-light-danger':setId==3}">
                                                <span class="float-left">{{$ml.get('PIECE')}}</span> 
                                                <span class="float-right" v-if="setId==1">{{totalRounded(info.open.count)}}</span>
                                                <span class="float-right" v-if="setId==2">{{totalRounded(info.won.count)}}</span>
                                                <span class="float-right" v-if="setId==3">{{totalRounded(info.lose.count)}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div> 
                                <div class="col-12 col-xl-9">
                                    <div class="align-self-center">
                                        <bar-chart :data="barChartDataCount" class="mt-3" :color="pieColor" :options="barChartOptions" :labels="barChartLabels"></bar-chart>
                                    </div>
                                    <div class="align-self-center p-4">
                                        <p class="text-center f-15 font-family-bold font-weight-normal m-0">{{$ml.get('PIECE_PERSON_GRAPHIC')}}</p> 
                                    </div>
                                </div>           
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    
    <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
</div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'
import BarChart from '../charts/HorizontalBarChart.js'
import PieChart from './PieChart.vue'
export default {
    data () {
        return {
            pieData:[],
            pieDataCount:[],
            pieLabels:[this.$ml.get("OPEN_OPPORTUNITIES"),this.$ml.get("WINNING_OPPORTUNITY"),this.$ml.get("LOSS_OPPORTUNITY")],
            pieColor:['#fd7e14','#58b368','#e41749'],
            barChartLabels:[],
            barChartData:[
                {
                    label: this.$ml.get('AMOUNT'),
                    backgroundColor: [],
                    data: []
                },
            ],
            barChartDataCount:[
                {
                    label: this.$ml.get('PIECE'),
                    backgroundColor: [],
                    data: []
                },
            ],
            barChartOptions: {
                height:300,
                legend: { display: false },
                responsive: false,
                scales: {
                    xAxes: [{
                        ticks: {
                        maxRotation: 90,
                        minRotation: 80
                        }
                    }],
                    yAxes: [{
                        ticks: {
                        beginAtZero: true
                        }
                    }]
                }
            },
            tabs:"currency",
            setDate:undefined,
            setId:0,
            selectDate:undefined,
            greenActive:false,
            redActive:false,
            yellowActive:false,
            greyActive:true,
            clickSelectUser:undefined,
            dealReports:[],
            dealReportsCount:[],
            info:{
                open:{
                    count:0,
                    total:0
                },
                won:{
                    count:0,
                    total:0
                },
                lose:{
                    count:0,
                    total:0
                },
            },
            oldDateVal:undefined,
            newDateVal:undefined,
            userId:"all",
            showDate:{},
            dealsTotalAmount:0,
            dateTypeSelector:'addDate',
            dateTypeList:[
                {value:"addDate",name:this.$ml.get('CREATION_DATE')},
                {value:"expectedDate",name:this.$ml.get('ESTIMATED_CLOSING')},
                {value:"closedDate",name:this.$ml.get('CLOSING_DATE')},
            ],
            dateShortcuts:[
                { key: 'thisQuarter', label: this.$ml.get('THIS_QUARTER'), value: 'quarter' },//
                { key: 'thisMonth', label: this.$ml.get('THIS_MONTH'), value: 'month' },//
                { key: 'lastMonth', label: this.$ml.get('LAST_MONTH'), value: '-month' },//
                { key: 'thisWeek', label: this.$ml.get('THIS_WEEK'), value: 'isoWeek' },//
                { key: 'lastWeek', label: this.$ml.get('LAST_WEEK'), value: '-isoWeek' },//
                { key: 'thisYear', label: this.$ml.get('THIS_YEAR'), value: 'year' },//
                { key: 'lastYear', label: this.$ml.get('LAST_YEAR'), value: '-year' }//
            ],
            defaultCurrency:localStorage.defaultCurrency
            //yesil:58b368
            //kırmızı:e41749
            //sarı:fab95b
            //mavi:36aed8
        }
    },
    props:["user","users","permissions","activeTab"],
    components:{
        BarChart,
        "report-chart":PieChart,
    },
    computed:{
        ...mapState([
            'baseUrl',
            'reports',
            'reportLoading'
        ]),
        ...mapGetters(['localeLang'])
    },
    methods:{
        formatDate(value, format) {
            return this.$moment(value).format(format);
        },
        totalRounded(value){
            if(value !== undefined && value !== null){
                value = Math.round(value*100)/100
                return value
            }
            return 0
        },
        toPriceModel:function(price){
            if(price!==undefined && price!==null){
                return price.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\,")
            }
            return ''
        },
        toFix: function(val){
            if(val!==undefined && val!==null && !isNaN(val)){
                return Number(val).toFixed(2);
            }
            return ''
        },
        numberWithCommas(val) {
            if(val!==undefined && val!==null){
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            return ''
        },
        ...mapActions([
            'updateLoading',
            'getReport'
        ]),
        clear(){
            this.barChartData=[
                {
                    label: this.$ml.get('AMOUNT'),
                    backgroundColor: [],
                    data: []
                },
            ],
            this.info={
                open:{
                    count:0,
                    total:0
                },
                won:{
                    count:0,
                    total:0
                },
                lose:{
                    count:0,
                    total:0
                },
            },
            this.greyActive=true
            this.redActive=false
            this.greenActive=false
            this.yellowActive=false
        },
        getReports(field){
            this.clear()
            let obj =this.dateFormat(field)
            if(this.$can("can_see_other_users_deals_report")){
                if(this.userId!=undefined && this.userId!="all"){
                    obj["userId"]=this.userId
                }
            }else{
                if(this.user._id!=undefined){
                  //  obj["userId"]=this.user._id.$oid
                }else{
                    return false
                }
                
            }

             
            if(this.activeTab=="deal"){
                this.getReport(obj)
            }
            
        },
        createdChart(){
            this.info={
                open:{
                    title:this.$ml.get('NO_DATA'),
                    count:0,
                    total:0
                },
                won:{
                    title:this.$ml.get('NO_DATA'),
                    count:0,
                    total:0
                },
                lose:{
                    title:this.$ml.get('NO_DATA'),
                    count:0,
                    total:0
                },
            }
            this.dealReports=[]
            this.dealReportsCount=[]
            this.pieData=[]
            this.pieDataCount=[]
            if( this.reports.deals!=undefined){
                this.dealsTotalAmount=0
                this.reports.deals.forEach(element => {
                    console.log("this.dealsTotalAmount1")
                    console.log(this.dealsTotalAmount)
                    console.log("element.total")
                    console.log(element.total)
                    this.dealsTotalAmount=this.dealsTotalAmount+element.total
                    console.log("this.dealsTotalAmount2")
                    console.log(this.dealsTotalAmount)
                    if(element.status==1){
                        if(element.count!=undefined){
                            this.dealReports[0]=element.total
                            this.dealReportsCount[0]=element.count
                            this.info["open"]={
                                title:this.$ml.get("OPEN_OPPORTUNITIES"),
                                count:element.count,
                                total:element.total
                            }
                            this.greyActive=false
                            this.redActive=false
                            this.greenActive=false
                            this.yellowActive=true
                        }
                    }
                    if(element.status==2){
                        if(element.count!=undefined){
                            this.dealReports[1]=element.total
                            this.dealReportsCount[1]=element.count
                            this.info["won"]={
                                title:this.$ml.get("WINNING_OPPORTUNITY"),
                                count:element.count,
                                total:element.total
                            }
                            this.greyActive=false
                            this.redActive=false
                            this.greenActive=true
                            this.yellowActive=false
                        }
                    }
                    if(element.status==3){
                        if(element.count!=undefined){
                            this.dealReports[2]=element.total
                            this.dealReportsCount[2]=element.count
                            this.info["lose"]={
                                title:this.$ml.get("LOSS_OPPORTUNITY"),
                                count:element.count,
                                total:element.total
                            }
                            this.greyActive=false
                            this.redActive=true
                            this.greenActive=false
                            this.yellowActive=false
                        }
                    }
                });

                this.pieLabels.forEach((element,index) => {
                    let obj={}
                    obj["name"]=this.pieLabels[index]
                    obj["value"]=this.dealReports[index]
                    this.pieData.push(obj)
                });
                this.pieLabels.forEach((element,index) => {
                    let obj={}
                    obj["name"]=this.pieLabels[index]
                    obj["value"]=this.dealReportsCount[index]
                    this.pieDataCount.push(obj)
                });
            }
            
            this.barChartLabels=[]
            this.barChartData[0].data=[]
            this.barChartDataCount[0].data=[]
            let count=0
            if(this.reports.agents!=undefined && this.reports.agents.length>0){
                this.reports.agents.forEach(element => {
                    if(element.deals!=undefined && element.deals.length>0){
                        element.deals.forEach(deal => {
                            if(this.setId!=0){
                                if(deal.status==this.setId){
                                    if(deal.count){
                                        this.barChartLabels[count]=element.agent
                                        this.barChartData[0].data[count]=deal.total
                                        this.barChartDataCount[0].data[count]=deal.count
                                        count++ 
                                    }
                                }
                            }
                        })
                        
                    }
                })
                this.barChartData[0].backgroundColor=[]
                this.barChartDataCount[0].backgroundColor=[]
                for (let index = 0; index < count; index++) {
                    this.barChartData[0].backgroundColor.push(
                        '#' + (function co(lor){   return (lor +=
                        [0,1,2,3,4,5,6,7,8,9,'a','b','c','d','e','f'][Math.floor(Math.random()*16)])
                        && (lor.length == 6) ?  lor : co(lor); })(''));
                    this.barChartDataCount[0].backgroundColor.push(
                    '#' + (function co(lor){   return (lor +=
                    [0,1,2,3,4,5,6,7,8,9,'a','b','c','d','e','f'][Math.floor(Math.random()*16)])
                    && (lor.length == 6) ?  lor : co(lor); })(''));
                }
            }
        },
        dateFormat(format){
            let obj ={}
            obj['dateField']=this.dateTypeSelector
            if(format=='today'){
                this.selectDate=undefined
                let start=this.$moment().format("YYYY-MM-DD")
                let end = this.$moment().format("YYYY-MM-DD")
                //let obj = {}
                obj["beginDate"]=start
                obj["endDate"]=end
                this.showDate=obj
                return obj
            }else if(format=='tomorrow'){
                this.selectDate=undefined
                let start=this.$moment(new Date()).add(1,'days').format("YYYY-MM-DD");
                let end = this.$moment(new Date()).add(1,'days').format("YYYY-MM-DD");
                //let obj = {}
                obj["beginDate"]=start
                obj["endDate"]=end
                this.showDate=obj
                return obj
            }else if(format=='mounth'){
                this.selectDate=undefined
                let start=this.$moment().format("YYYY-MM-01")
                let end = this.$moment().format("YYYY-MM-DD")
                //let obj = {}
                obj["beginDate"]=start
                obj["endDate"]=end
                this.showDate=obj
                return obj
            }else if(format=='selectDate'){
                if(this.selectDate.start!=undefined && this.selectDate.start!=null && this.selectDate.end!=undefined && this.selectDate.end!=null){
                    //let obj = {}
                    obj["beginDate"]=this.selectDate.start
                    obj["endDate"]=this.selectDate.end
                    this.setDate="selectDateButton"
                    this.showDate=obj
                    return obj
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warn', 
                        title:'Tarih boş geçilemez!',
                        text: 'Lütfen raporlamak istediğiniz tarih arası seçiniz!'
                    })
                }
            }
            else{
                //Default mounth
                this.selectDate=undefined
                let start=this.$moment().format("YYYY-MM-01")
                let end = this.$moment().format("YYYY-MM-DD")
                //let obj = {}
                obj["beginDate"]=start
                obj["endDate"]=end
                this.showDate=obj
                return obj
            }
        },
        changeDate(){
            if(this.setDate==this.oldDateVal){
                this.setDate=undefined
            }
            this.getReports(this.setDate)
        },
    },
    created(){
        this.selectDate=this.$moment().format("YYYY-MM-DD")
        
        this.getReports("mounth")
    },
    watch:{
        user:function(){
            this.getReports("mounth")
        },
        userId:function(){
            this.getReports(this.setDate)
            this.setId=0
        },
        setDate:function(oldVal,newVal){
            this.oldDateVal=oldVal
            this.newDateVal=newVal
        },
        setId:function(){
            this.barChartLabels=[]
            this.barChartData[0].data=[]
            this.barChartDataCount[0].data=[]
            this.pieData=[]
            this.pieDataCount=[]
            if( this.reports.deals!=undefined){
                if(this.setId==0){
                    this.createdChart()
                }else{
                    this.dealReports=[]
                    let count=0
                    if(this.reports.agents!==undefined){
                        this.reports.agents.forEach(element => {
                            if(element.deals!=undefined && element.deals.length>0){
                                element.deals.forEach(deal => {
                                    if(this.setId!=0){
                                        if(deal.status==this.setId){
                                            this.barChartLabels[count]=element.agent
                                            this.barChartData[0].data[count]=deal.total
                                            this.barChartDataCount[0].data[count]=deal.count
                                            count++ 
                                        }
                                    }
                                })
                            }
                        })
                    }else{
                        if(this.reports.deals!=undefined && this.reports.deals.length>0){
                            this.reports.deals.forEach(deal => {
                                if(this.setId!=0){
                                    if(deal.status==this.setId){
                                        this.barChartLabels[count]=this.user.name
                                        this.barChartData[0].data[count]=deal.total
                                        this.barChartDataCount[0].data[count]=deal.count
                                        count++ 
                                    }
                                }
                            })
                        }
                        
                    }
                    this.barChartData[0].backgroundColor=[]
                    this.barChartDataCount[0].backgroundColor=[]
                    for (let index = 0; index < count; index++) {
                        this.barChartData[0].backgroundColor.push(
                            '#' + (function co(lor){   return (lor +=
                            [0,1,2,3,4,5,6,7,8,9,'a','b','c','d','e','f'][Math.floor(Math.random()*16)])
                            && (lor.length == 6) ?  lor : co(lor); })(''));
                        this.barChartDataCount[0].backgroundColor.push(
                        '#' + (function co(lor){   return (lor +=
                        [0,1,2,3,4,5,6,7,8,9,'a','b','c','d','e','f'][Math.floor(Math.random()*16)])
                        && (lor.length == 6) ?  lor : co(lor); })(''));
                    }
                    this.reports.deals.forEach(element => {
                        if(element.status==1 && this.setId==1){
                            if(element.count!=undefined){
                                this.dealReports[0]=element.total
                                this.dealReportsCount[0]=element.count
                                this.info["open"]={
                                    title:this.$ml.get("OPEN_OPPORTUNITIES"),
                                    count:element.count,
                                    total:element.total
                                }
                                this.greyActive=false
                                this.redActive=false
                                this.greenActive=false
                                this.yellowActive=true
                            }
                        }
                        if(element.status==2 && this.setId==2){
                            if(element.count!=undefined){
                                this.dealReports[1]=element.total
                                this.dealReportsCount[1]=element.count
                                this.info["won"]={
                                    title:this.$ml.get("WINNING_OPPORTUNITY"),
                                    count:element.count,
                                    total:element.total
                                }
                                this.greyActive=false
                                this.redActive=false
                                this.yellowActive=false
                                this.greenActive=true
                            }
                        }
                        if(element.status==3 && this.setId==3){
                            if(element.count!=undefined){
                                this.dealReports[2]=element.total
                                this.dealReportsCount[2]=element.count
                                this.info["lose"]={
                                    title:this.$ml.get("LOSS_OPPORTUNITY"),
                                    count:element.count,
                                    total:element.total
                                }
                                this.greyActive=false
                                this.yellowActive=false
                                this.greenActive=false
                                this.redActive=true
                            }
                        }
                    });

                    this.pieData=this.dealReports
                        this.pieLabels.forEach((element,index) => {
                        let obj={}
                        obj["name"]=this.pieLabels[index]
                        obj["value"]=this.dealReports[index]
                        //this.pieData.push(obj)
                    });
                    this.pieLabels.forEach((element,index) => {
                        let obj={}
                        obj["name"]=this.pieLabels[index]
                        obj["value"]=this.dealReportsCount[index]
                        //this.pieDataCount.push(obj)
                    });

                }
            }
        },
        reports:{
            handler(){
                this.createdChart()
            },
            deep:true
        },
        reportLoading:function(){
            if(this.reportLoading==true){
                 
            }
            
        },
        activeTab:function(){
            if(this.activeTab=="deal"){
                this.selectDate=this.$moment().format("YYYY-MM-DD")
                this.getReports("mounth")
            }
        },
    },
}
</script>

<style scoped>
    .nav-tabs{
        background-color:#F4F4F4;
        border-bottom:0;
    }
    .nav-link{
        color: #354052;
    }
    .card-header{
        color:white;
    }
    .border-warning{
        border-color:#fd7e14!important;
    }
    .bg-warning{
        background-color: #fd7e14!important;
    }
    .bg-light-warning{
        background-color: rgba(242, 129, 0, 0.05);
    }
    .bg-light-success{
        background-color: rgba(57, 181, 74, 0.05);
    }
    .bg-light-danger{
        background-color: rgba(239, 66, 72, 0.05);
    }
    .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
        color: #354052;
        background-color:transparent;
        border-color:transparent;
        border-bottom: 2px solid #1991EB;
    }
    .tab-content>.tab-pane {
        display: block;
        height: 0;
        overflow: hidden;
    }
    .tab-content>.tab-pane.active {
        height: auto;
    }
    .selectUser{
        background-color: white;
        border: 1px solid #3767a0;
        color: black;
    }
    .dateOkeyButton{
        background-color: #3767a0;
        border: 1px solid #3767a0;
        color: white;
    }
    .dateCancelButton{
        background-color: #e41749;
        border: 1px solid #e41749;
        color: white;
    }
    .dealFilterMenu button{
        color: #6a6b75;
        background-color: transparent;
    }
    .dealFilterMenu button.active{
        background-color: #3767a0;
        color: white;
    }
    .dealFilterMenu {
        display: inline-block;
        margin: auto;
    }
    .mainPanel{
        display: flex;
        border: 2px solid ;
        border-radius: 20px;
    }
    .mainPanel div:first-child{
        border-right:  2px solid;
    }
    .iptal:before{
    color:red
}
 @media (max-width:500px){
        .dealFilterMenu button{
            padding: 0.4rem;
            font-size: 12px;
           
        }
        .dealFilterMenu {
            margin-bottom: 15px;
        }
}
@media (min-width: 434px){
        .dealFilterMenu {
            display: flex;
            float: right;
        }
        .dealFilterMenu  >  span {
            margin-right: 10px !important;
        }
}
.searchTitle{
    font-size: 16px;
    padding: 10px;
    color: #6a6b75;;
  }
  .underline{
    border-bottom: 1px solid rgba(0, 0, 0, .125) ;
  }
  @media screen and (min-width: 1366px) {
    .searchTitle{
      font-size:21px;
    }
}
</style>
